import { z } from 'zod';

import { LanguageEnum } from '../../enums';

export const LanguageSchema = z.object({
  language: z.nativeEnum(LanguageEnum),
});

export type ILanguageDto = z.infer<typeof LanguageSchema>;
